import { createSelector, createFeatureSelector } from '@ngrx/store';
import { LanguageState } from '@models/iLanguageState';

export const languageSelector = createFeatureSelector<LanguageState>('language');
export const getLanguagesSelector = createSelector(languageSelector, (state: LanguageState) => state);


